import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { NAV_ITEMS, Logo } from "./AppLayout";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export function MobileNav() {
  const [open, setOpen] = useState(false);
  const { isAdmin } = useAuth();
  const items = isAdmin ? [...NAV_ITEMS, { to: "/admin", label: "Administration", icon: ShieldCheck, id: "admin" }] : NAV_ITEMS;
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="xl:hidden" data-testid="mobile-nav-trigger" aria-label="Menu">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72">
        <SheetHeader>
          <SheetTitle><Logo className="h-12" /></SheetTitle>
        </SheetHeader>
        <nav className="mt-6 flex flex-col gap-1">
          {items.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${id}-link`}
              className={({ isActive }) =>
                cn("flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold",
                  isActive ? "bg-accent text-primary" : "text-stone-700 hover:bg-stone-100")
              }
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
